import gql from 'graphql-tag'
import api from './apiClient'

export default {
  readSubscriptionsByCliente: _id =>
    api
      .send({
        query: gql`
          query READ_SUBSCRIPTIONS_BY_CLIENTE($_id: ID!) {
            Cliente {
              readSubscriptionsByCliente(_id: $_id) {
                _id
                next
                freq
                state
                _idFactura
                consecutivo
                total

                createdAt
                updatedAt
              }
            }
          }
        `,
        variables: { _id }
      })
      .then(result => result.data.data.Cliente.readSubscriptionsByCliente),

  readBitacora: (_id, _idCliente) =>
    api
      .send({
        query: gql`
          query READ_BITACORA($_id: ID!, $_idCliente: ID!) {
            Cliente {
              readBitacora(_id: $_id, _idCliente: $_idCliente) {
                fecha
                consecutivo
                _idFactura
              }
            }
          }
        `,
        variables: { _id, _idCliente }
      })
      .then(result => result.data.data.Cliente.readBitacora),

  subscribe: (_id, input) =>
    api
      .send({
        query: gql`
          mutation SUBSCRIBE($_id: ID!, $input: SubscriptionInput!) {
            Cliente {
              subscribe(_id: $_id, input: $input)
            }
          }
        `,
        variables: {
          _id,
          input
        }
      })
      .then(result => result.data.data.Cliente.subscribe),

  deleteSubscriptions: ({ _id, input, isDelete }) =>
    api
      .send({
        query: gql`
          mutation deleteSubscriptions($_id: ID!, $input: [ID!]!, $isDelete: Boolean) {
            Cliente {
              deleteSubscriptions(_id: $_id, input: $input, isDelete: $isDelete) {
                _id
                state
                message
              }
            }
          }
        `,
        variables: { _id, input, isDelete }
      })
      .then(result => result.data.data.Cliente.deleteSubscriptions),

  updateSubscription: (_id, _idCliente, next, freq) =>
    api
      .send({
        query: gql`
          mutation UPDATE_SUBSCRIPTION($_id: ID!, $_idCliente: ID!, $next: Date!, $freq: String!) {
            Cliente {
              updateSubscription(_id: $_id, _idCliente: $_idCliente, next: $next, freq: $freq)
            }
          }
        `,
        variables: {
          _id,
          _idCliente,
          next,
          freq
        }
      })
      .then(result => result.data.data.Cliente.updateSubscription)
}
